// extracted by mini-css-extract-plugin
export default {"section":"paymentmethod_section__VDHpE","sectionHeading":"paymentmethod_sectionHeading__NSZi-","table":"paymentmethod_table__DZNRm"};